// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__ZODbl","pageContent":"layout_pageContent__BPMW2"};